import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CONFIG } from '../interceptors/loader.interceptor';
import { HttpContextConfig } from '../models/http-context-config';

const serviceURL = `${environment.api}/arguments/`;

@Injectable({
  providedIn: 'root',
})
export class ArgumentsService {
  serviceURL: string;

  constructor(private http: HttpClient) {}

  getArguments() {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    return this.http.get<any>(serviceURL + 'cardArgument');
  }

  destroyArgument(id: number) {
    return this.http.delete<any>(serviceURL + `${id}/destroy`);
  }

  updateArgument(data: { alias: string; description: string }, id: number) {
    return this.http.put<any>(serviceURL + `${id}/update`, data);
  }

  storeArgument(data: {
    alias: string;
    description: string;
    parent_id: number;
    skill_level: string;
  }) {
    return this.http.post<any>(serviceURL + 'store', data);
  }

  getStrenghtpoint(arr: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    return this.http.post<any>(
      serviceURL + 'getStrenghtpoint',
      { selected_strenght: arr },
      { context }
    );
  }

  getMicroArgument(id: any, data?: any) {
    const context = new HttpContext().set(CONFIG, { noSpinner: true });
    return this.http.post<any>(serviceURL + `${id}/microArguments`, data, {
      context,
    });
  }
}
